module.exports = __webpack_public_path__ + "static/img/9areaB_01.d697d46.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/9areaB_01.png
// module id = 1233
// module chunks = 1